import "./style.scss"
interface Props {
  icon: React.ReactNode
  title: string
}
export const Chip = ({ icon, title }: Props) => {
  return (
    <div className="iban-chip">
      <div className="iban-chip__icon">{icon}</div>
      <div className="iban-chip__title">{title}</div>
    </div>
  )
}
